import React from 'react';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const styles = {
  control: {
    display: 'inline-flex',
    minHeight: 36,
    alignItems: 'center',
    gap: 8,
    padding: '4px 6px',
    border: 0,
    borderRadius: 8,
    background: 'transparent',
    color: '#1e2248',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'background-color 140ms ease',
  },
  track: {
    position: 'relative',
    display: 'inline-flex',
    width: 34,
    height: 20,
    flex: '0 0 34px',
    alignItems: 'center',
    borderRadius: 999,
    transition: 'background-color 160ms ease, box-shadow 160ms ease',
  },
  thumb: {
    position: 'absolute',
    top: 3,
    width: 14,
    height: 14,
    borderRadius: '50%',
    background: '#fff',
    boxShadow: '0 1px 3px rgba(30, 34, 72, 0.24)',
    transition: 'left 160ms ease',
  },
  copy: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 5,
    whiteSpace: 'nowrap',
  },
  label: { fontSize: 12, fontWeight: 650 },
  detail: { color: '#66708a', fontSize: 12 },
};

const AutoFillControl = ({ enabled, limit, unit, onChange, showTarget = true }) => {
  const t = useLocalizedMessage();
  const detail = enabled && showTarget
    ? t('empty.query.autofill.up.to', { limit, unit })
    : !enabled ? t('empty.query.autofill.selected.only') : null;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label={t('empty.query.autofill.label')}
      style={styles.control}
      onClick={() => onChange(!enabled)}
      onMouseEnter={(event) => { event.currentTarget.style.backgroundColor = 'var(--kea-color-primary-surface)'; }}
      onMouseLeave={(event) => { event.currentTarget.style.backgroundColor = 'transparent'; }}
    >
      <span
        aria-hidden="true"
        style={{
          ...styles.track,
          background: enabled ? 'var(--kea-color-primary)' : '#c8d1d9',
          boxShadow: enabled ? '0 0 0 1px rgba(var(--kea-color-primary-rgb), 0.12)' : 'none',
        }}
      >
        <span style={{ ...styles.thumb, left: enabled ? 17 : 3 }} />
      </span>
      <span style={styles.copy}>
        <span style={styles.label}>{t('empty.query.autofill.label')}</span>
        {detail && <span style={styles.detail}>{detail}</span>}
      </span>
    </button>
  );
};

export default AutoFillControl;
